import { render } from "./search.vue?vue&type=template&id=6e9bedc0"
const script = {}
script.render = render

export default script